import { Link } from "react-router-dom";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-white";

const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-sm sm:text-base",
};

const variants = {
  gold: "bg-gold text-[#0B132B] hover:bg-[#E5C158] hover:shadow-[0_0_24px_rgba(212,175,55,0.4)]",
  outline: "border border-gold/60 text-gold hover:bg-gold/10",
  slate: "border border-slate-300 bg-[#F0EDE4] text-[#0B132B] hover:border-slate-500",
};

export const CtaButton = ({ to, href, children, variant = "gold", size = "md", className = "", ...rest }) => {
  const cls = `${base} ${sizes[size]} ${variants[variant]} ${className}`;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <Link to={to} className={cls} {...rest}>{children}</Link>;
};
